<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">
        <!-- Header -->
        <Header></Header>

        <!-- Menu -->
        <v-layout justify-center>
            <v-flex xs12 style="background-color: #527281">
                <v-container>
                    <v-layout>
                        <v-flex xs1 style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px" @click="$router.push('/home').catch(err => {})">
                                หน้าแรก
                            </v-btn>
                        </v-flex>
                        <v-icon style="color: white">play_arrow</v-icon>
                        <v-flex xs3 style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px">แสดงผลคุณลักษณะเฉพาะ</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>

        <!-- Show Detail -->
        <v-layout justify-center>
            <v-flex xs12>
                <v-layout justify-center>
                    <v-flex xs12 class="mt-12 mb-4" style="font-size: 36px; color: #D97C57; font-weight: bold">
                        แสดงผลคุณลักษณะเฉพาะ
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-flex xs10 class="mb-12">
                        <v-card class="pb-12">
                            <v-layout>
                                <v-flex xs12 class="pa-12 form-detail">
                                    <v-form>
                                        <v-layout justify-center>
                                            <v-flex shrink xs12>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex xs5 class="mr-4 mt-8" style="text-align: right">
                                                                    เลขที่สิ่งอุปกรณ์ :
                                                                </v-flex>
                                                                <v-flex xs5 class="mt-8">
                                                                    <v-text-field
                                                                            v-model="form.spec_no"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex xs5 class="mr-4" style="text-align: right">
                                                                    หมายเลข สป. :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.spec_code"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4" style="text-align: right">
                                                                    ชื่อ สป. (ไทย) :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.name_th"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4" style="text-align: right">
                                                                    ชื่อ สป. (อังกฤษ) :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.name_en"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4" style="text-align: right">
                                                                    กลุ่ม สป. :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.group_num"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4" style="text-align: right">
                                                                    กลุ่มหลักสิ่งอุปกรณ์ :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.main_group"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4" style="text-align: right">
                                                                    อุปกรณ์กลุ่มย่อยของอุปกรณ์ :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.sub_group"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4" style="text-align: right">
                                                                    ปีที่จัดทำ :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.year"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4" style="text-align: right">
                                                                    ประเภท :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.type_spec"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4" style="text-align: right">
                                                                    หน่วยนับ :
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                            v-model="form.unit"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                <v-layout style="font-size: 18px">
                                                                <v-flex shrink xs5 class="mr-4 mb-12" style="text-align: right">
                                                                    GPSC :
                                                                </v-flex>
                                                                <v-flex xs5 class="mb-12">
                                                                    <v-text-field
                                                                            v-model="form.gpsc"
                                                                            background-color="#E5E5E5"
                                                                            value=""
                                                                            item-color="#84A2A8"
                                                                            solo
                                                                            readonly
                                                                            required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
<!--                                                        <div>-->
<!--                                                            <v-layout style="font-size: 18px">-->
<!--                                                                <v-flex shrink xs5 class="mr-4 mt-6" style="text-align: right">-->
<!--                                                                    กลุ่ม สป. :-->
<!--                                                                </v-flex>-->
<!--                                                                <v-flex xs5 class="mt-6">-->
<!--                                                                    <v-textarea-->
<!--                                                                            v-model="form.group_num"-->
<!--                                                                            rows="15"-->
<!--                                                                            background-color="#E5E5E5"-->
<!--                                                                            value=""-->
<!--                                                                            item-color="#84A2A8"-->
<!--                                                                            solo-->
<!--                                                                            required>-->
<!--                                                                    </v-textarea>-->
<!--                                                                </v-flex>-->
<!--                                                            </v-layout>-->
<!--                                                        </div>-->
<!--                                                        <div>-->
<!--                                                            <v-layout style="font-size: 18px">-->
<!--                                                                <v-flex shrink xs5 class="mr-4 mb-12" style="text-align: right">-->
<!--                                                                    GPSC :-->
<!--                                                                </v-flex>-->
<!--                                                                <v-flex xs5 class="mb-12">-->
<!--                                                                    <v-text-field-->
<!--                                                                            v-model="form.gpsc"-->
<!--                                                                            background-color="#E5E5E5"-->
<!--                                                                            value=""-->
<!--                                                                            item-color="#84A2A8"-->
<!--                                                                            solo-->
<!--                                                                            required>-->
<!--                                                                    </v-text-field>-->
<!--                                                                </v-flex>-->
<!--                                                            </v-layout>-->
<!--                                                        </div>-->
                                                <div v-if="url !==''">
                                                    <v-btn @click="getOrder()" class="mx-2" style="background-color: #527281;color: white">
                                                        สั่งพิมพ์เพื่อจัดหา
                                                    </v-btn>
                                                    <v-btn @click="getView()" class="mx-2" style="background-color: #527281;color: white">
                                                        สั่งพิมพ์เพื่อดู
                                                    </v-btn>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-form>
                                </v-flex>
                            </v-layout>

                            <v-card flat  v-if="url !== ''" class="card-pdf" style="background-color: rgba(242, 242, 242,0.4);">
                                <v-layout justify-center>
                                    <v-flex class="form-pdf">
                                        <v-layout>
                                            <v-flex>
                                                <iframe :src="url" width="795" height="1042"></iframe>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <loading
                color="#527281"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="fullPage"
        ></loading>

        <!-- Footer -->
        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import { domain } from "../util/Constants"
    import { mapState } from "vuex";
    import pdf from 'vue-pdf'
    import Swal from 'sweetalert2'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "ShowDetail",
        components: {
            Footer,
            Header,
            pdf: pdf,
            Loading,
        },
        created() {
            this.viewDataTool();
        },
        mounted() {

        },
        data: () => ({
            isLoading: false,
            fullPage: true,
            url: '',
            form: {
                spec_no: '',
                spec_code: '',
                name_th: '',
                name_en: '',
                unit: '',
                year: '',
                type_spec: '',
                group_num: '',
                main_group: '',
                sub_group: '',
                gpsc: '',
            },
        }),
        computed: {
            // Map Vuex state.
            ...mapState({
                dataUser: stat => {
                    return stat.Auth.user
                },
            })
        },
        methods: {
            nextPage() {
                if (this.page > this.pageCount) {
                    this.page = this.page + 1;
                }
            },
            backPage() {
                if (this.page > 1) {
                    this.page = this.page - 1;
                }
            },
            getOrder() {
                this.$store.dispatch('Med/getMed', this.$route.query.id).then(data => {
                    let data_order = {
                        group_num: data.group_num,
                        medspec_id: data.id,
                        year: data.year,
                        print_type: '2',
                        user_id: this.dataUser.id,
                        status: data.status,
                    };
                    this.$store.dispatch('Common/saveOrder', data_order).then(() => {
                        this.getOrderPdf(this.$route.query.id);
                    })
                })
            },
            getView() {
                this.$store.dispatch('Med/getMed', this.$route.query.id).then(data => {
                    let data_order = {
                        group_num: data.group_num,
                        medspec_id: data.id,
                        year: data.year,
                        print_type: '1',
                        user_id: this.dataUser.id,
                        status: data.status,
                    };
                    this.$store.dispatch('Common/saveViewOrder', data_order).then(() => {
                        this.getViewPdf(this.$route.query.id);
                    })
                })
            },
            getOrderPdf(id) {
                // window.open(domain+'/get-order-pdf/'+id);
                window.open(domain+`/get-order-pdf/${id}?user_id=${this.dataUser.id}`);
            },
            getViewPdf(id) {
                window.open(domain+'/get-view-pdf/'+id);
            },
            viewDataTool() {
                this.isLoading = true;
                this.$store.dispatch('Med/getMed', this.$route.query.id).then(data => {
                    // console.log('View', data);
                    this.form.spec_no = data.spec_no ? data.spec_no : '-';
                    this.form.spec_code = data.spec_code ? data.spec_code : '-';
                    this.form.name_th = data.name_th ? data.name_th : '-';
                    this.form.name_en = data.name_en ? data.name_en : '-';
                    this.form.main_group = data.spec_group.main_group_desc ? data.spec_group.main_group_desc : '-';
                    if (data.spec_group.group_level === '1'){
                        this.form.sub_group = '-';
                    } else if (data.spec_group.group_level === '2'){
                        this.form.sub_group = data.spec_group.sub_group1_desc ? data.spec_group.sub_group1_desc : '-';
                    } else if (data.spec_group.group_level === '3'){
                        this.form.sub_group = data.spec_group.sub_group2_desc ? data.spec_group.sub_group2_desc : '-';
                    } else if (data.spec_group.group_level === '4'){
                        this.form.sub_group = data.spec_group.sub_group3_desc ? data.spec_group.sub_group3_desc : '-';
                    }
                    this.form.unit = data.unit ? data.unit : '-';
                    this.form.year = data.year ? data.year : '-';
                    this.form.type_spec = data.type_spec ? data.type_spec : '-';
                    this.form.group_num = data.group_num ? data.group_num : '-';
                    this.form.gpsc = data.gpsc ? data.gpsc : '-';
                    this.url = data.path_file ? data.path_file : '';
                })
                this.isLoading = false;
            },

            onDocumentErrored(e) {
                this.documentError = e.text;
            },
        },

    }
</script>

<style lang="scss">
    .form-detail {
        .v-text-field.v-text-field--solo .v-input__control {
            min-height: 35px !important;
        }
        .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
            border-radius: 10px;
            box-shadow: unset;
        }

        .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
            color: #527281;
        }

        .theme--light.v-select .v-select__selections {
            color: #527281;
        }

        .theme--light.v-select:hover {
            color: #527281;
        }

        .v-icon.v-icon {
            color: #527281 !important;
            caret-color: #527281 !important;
        }

        .v-text-field.v-text-field--enclosed .v-text-field__details {
            margin-bottom: 0;
        }

        .v-input__slot {
            margin-bottom: 0;
        }

        .v-menu__content.theme--light.menuable__content__active {
            text-align: left !important;
        }
    }
    .form-pdf {
        .v-text-field.v-text-field--solo .v-input__control {
            min-height: 35px !important;
        }
        .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
            border-radius: 3px;
            box-shadow: unset;
        }

        .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
            color: #527281;
        }

        .theme--light.v-select .v-select__selections {
            color: #527281;
        }

        .theme--light.v-select:hover {
            color: #527281;
        }

        .v-icon.v-icon {
            color: white !important;
            caret-color: #527281 !important;
        }

        .v-text-field.v-text-field--enclosed .v-text-field__details {
            margin-bottom: 0;
        }

        .v-input__slot {
            margin-bottom: 0;
        }

        .v-menu__content.theme--light.menuable__content__active {
            text-align: left !important;
        }
    }
    .card-pdf {
        padding-top: 50px;
        padding-right: 50px;
        padding-bottom: 50px;
        padding-left: 50px;
        margin-left: 100px;
        margin-right: 100px;
        margin-top: 50px;
        margin-bottom: 50px;
    }

</style>

